'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var React = require('react');
var bumbag = require('bumbag');
var fileSaver = require('file-saver');
var Loads = require('react-loads-next');
var sdk = require('@medipass/web-sdk');
var WithErrorMessage = require('../../../WithErrorMessage.js');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('clsx');
require('../../../components/ErrorMessage.js');
require('@babel/runtime/helpers/defineProperty');
require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
require('lodash/get');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var fileSaver__default = /*#__PURE__*/_interopDefaultLegacy(fileSaver);
var sdk__default = /*#__PURE__*/_interopDefaultLegacy(sdk);

function MedicareTransactionPDF(_ref) {
  var transactionId = _ref.transactionId;
  var getPDF = React__default["default"].useCallback( /*#__PURE__*/_asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee() {
    var pdf, blob;
    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return sdk__default["default"].transactions.getTransactionPDF(transactionId);

          case 2:
            pdf = _context.sent;
            // @ts-expect-error TS(2322): Type 'Record<string, any>' is not assignable to ty... Remove this comment to see the full error message
            blob = new Blob([pdf], {
              type: 'application/pdf'
            });
            fileSaver__default["default"].saveAs(blob, 'medicare_statement.pdf');

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [transactionId]); // @ts-expect-error TS(2554): Expected 3 arguments, but got 1.

  var _useDeferredLoads = Loads.useDeferredLoads(getPDF),
      downloadPDF = _useDeferredLoads.load,
      isPending = _useDeferredLoads.isPending,
      isRejected = _useDeferredLoads.isRejected;

  return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
    onClick: downloadPDF
  }, "View Medicare statement"), isPending && /*#__PURE__*/React__default["default"].createElement(bumbag.Spinner, {
    className: "flex justify-center",
    marginLeft: "major-1",
    size: "small"
  }), isRejected && /*#__PURE__*/React__default["default"].createElement(WithErrorMessage["default"], {
    isActive: true,
    description: "Unable to download Medicare statement"
  }));
}

exports["default"] = MedicareTransactionPDF;
